import {
  get as getCookie,
  remove as removeCookie,
  set as setCookie,
} from "../js/utils/cookie/cookie";

export default class ContactForm {
  /**
   * Initialize ContactForm instance.
   *
   * @param {string} formSelector - CSS selector for the form.
   * @param {string} startEvent - Name of the cookie for the start event.
   * @param {string} submitEvent - Name of the cookie for the submit event.
   */
  constructor(formSelector, startEvent, submitEvent) {
    this.startEvent = startEvent;
    this.submitEvent = submitEvent;

    this.contactForm = document.querySelector(formSelector);

    if (this.contactForm) {
      this._init();
    }

    this._bindCookies();
  }

  /**
   * Bind initial events to the form.
   *
   * @private
   */
  _init() {
    this.contactForm.addEventListener(
      "input",
      () => ContactForm._onFirstInput(this.startEvent),
      { once: true }
    );
  }

  /**
   * Bind cookies for form submission tracking.
   *
   * @private
   */
  _bindCookies() {
    if (getCookie(this.submitEvent)) {
      ContactForm._onFormSubmit(this.submitEvent);
    }
  }

  /**
   * Handle the first input event. Set a cookie and push event to dataLayer.
   *
   * @param {string} startEvent - Name of the cookie for the start event.
   * @private
   * @static
   */
  static _onFirstInput(startEvent) {
    if (!getCookie(startEvent)) {
      ContactForm._pushToDataLayer("start");
    }

    setCookie(startEvent, 1, {
      path: "/",
      end: 60 * 15,
      SameSite: "Lax",
      secure: true,
    });
  }

  /**
   * Handle form submission event. Remove the submission cookie and push event to dataLayer.
   *
   * @param {string} submitEvent - Name of the cookie for the submit event.
   * @private
   * @static
   */
  static _onFormSubmit(submitEvent) {
    ContactForm._pushToDataLayer("submit");
    removeCookie(submitEvent, { path: "/" });
  }

  /**
   * Push events to the data layer.
   *
   * @param {string} action - Event action name.
   * @private
   * @static
   */
  static _pushToDataLayer(action) {
    window.dataLayer.push({
      event: "Event",
      event_name: `kontaktformular_${action}`,
      [`kontaktformular_${action}`]: {
        pp_event_category: "kontaktformular",
        pp_event_action: action,
      },
    });
  }
}
